module.exports = __webpack_public_path__ + "static/media/read-less-chevron.208c3246.svg";